'use client'
import { findWalletBookWallet } from '@dynamic-labs/wallet-book';

const getMobileExperience = ({ mobileExperienceProp, walletBook, walletKey, }) => {
    // if the legacy prop is set, use that
    if (mobileExperienceProp && typeof mobileExperienceProp === 'string')
        return mobileExperienceProp;
    // if the wallet has a deeplink preference set from the DynamicContext, use that
    if (mobileExperienceProp === null || mobileExperienceProp === void 0 ? void 0 : mobileExperienceProp[walletKey])
        return mobileExperienceProp[walletKey];
    // if the wallet has a deeplink preference set in the wallet book, use that
    const walletRecord = findWalletBookWallet(walletBook, walletKey);
    if (walletRecord === null || walletRecord === void 0 ? void 0 : walletRecord.mobileExperience)
        return walletRecord.mobileExperience;
    if (mobileExperienceProp === null || mobileExperienceProp === void 0 ? void 0 : mobileExperienceProp.default)
        return mobileExperienceProp.default;
    return 'in-app-browser';
};

export { getMobileExperience };
